import { useEffect } from 'react';
import { logger } from '@/services/LoggingService';
import type { AssetType } from '@/types/assets';

interface Params {
  open: boolean;
  selectedAssetType: AssetType;
  equitySource: 'stock' | 'fund';
  searchQuery: string;
  fetchRecordCount: () => Promise<void> | void;
  fetchAssets: () => Promise<void> | void;
}

export function useAddAssetData({ open, selectedAssetType, equitySource, searchQuery, fetchRecordCount, fetchAssets }: Params) {
  // Fetch record count when type/source changes (avoid per-keystroke calls)
  useEffect(() => {
    if (!open) return;
    fetchRecordCount();
  }, [open, selectedAssetType, equitySource, fetchRecordCount]);

  // Debounced asset fetch for search/type/source changes
  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => {
      logger.debug('useAddAssetData', 'Triggering asset fetch after debounce', { searchQuery, selectedAssetType, equitySource });
      fetchAssets();
    }, 300);
    return () => clearTimeout(timer);
  }, [open, selectedAssetType, equitySource, searchQuery, fetchAssets]);
}
